import GroupTypeSelector from './GroupTypeSelector';

export default GroupTypeSelector;
